/**
 * Global Directives Registration
 *
 * Import and register all Vue directives here
 */

import permission from './permission'

const directives = {
  permission
}

export default {
  install(Vue) {
    Object.keys(directives).forEach(key => {
      Vue.directive(key, directives[key])
    })
  }
}
